import { render, staticRenderFns } from "./AlarmItem.vue?vue&type=template&id=b4d3a542&scoped=true"
import script from "./AlarmItem.vue?vue&type=script&lang=js"
export * from "./AlarmItem.vue?vue&type=script&lang=js"
import style0 from "./AlarmItem.vue?vue&type=style&index=0&id=b4d3a542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d3a542",
  null
  
)

export default component.exports